// eslint-disable-next-line @nx/enforce-module-boundaries
import { ComponentStyleConfig, StyleFunctionProps } from '@chakra-ui/react';
import { theme as defaultTheme } from '@chakra-ui/theme';

const fieldBaseStyles = {
  color: 'grey.900',
  border: '1px solid',
  borderColor: 'grey.400',
  borderRadius: 'lg',
  _disabled: {
    borderColor: 'grey.300',
    bg: 'grey.50',
    _hover: {
      borderColor: 'grey.300',
    },
  },
};

export const Select: ComponentStyleConfig = {
  sizes: {
    default: {
      field: {
        height: '12',
        width: '100%',
        border: '0.1',
        borderRadius: 'lg',
        borderColor: 'grey.400',
        bg: 'white',
        py: '3',
        pl: '4',
        pr: '2.5',
      },
    },
  },
  variants: {
    'republic-outline': (props: StyleFunctionProps) => ({
      ...defaultTheme.components.Select.variants?.outline(props),
      ...defaultTheme.components.Select.sizes?.md,
      field: {
        ...defaultTheme.components.Select.variants?.outline(props).field,
        ...fieldBaseStyles,

        _hover: { borderColor: 'blue.300' },
        _active: {
          borderColor: 'blue.500',
          boxShadow: 'none',
        },
        _focusVisible: {
          borderColor: 'blue.500',
          boxShadow: 'none',
        },
        background: 'brand.white',
        height: '10',

        ...defaultTheme.components.Select.sizes?.md.field,
        pb: 'px',
        pt: 0,
      },
      icon: {
        '> svg': {
          fill: 'grey.400',
        },
      },
    }),
    'republic-outline-lite': (props: StyleFunctionProps) => {
      return {
        ...defaultTheme.components.Select.variants?.outline(props),
        field: {
          ...defaultTheme.components.Select.variants?.outline(props).field,
          ...fieldBaseStyles,
          pl: '2.5',
          pr: '3',
          pt: '2.5',
          pb: '2',
          height: '42px',
          bg: 'white',
          outline: 'none',
          fontSize: 'md',
          lineHeight: 'base',
          fontWeight: 400,
          letterSpacing: 'less-tight',
          option: {
            color: 'black',
          },
          '> option[value=""]': {
            display: 'none',
          },
          _active: {
            borderColor: 'blue.500',
          },
          _hover: {
            borderColor: 'blue.300',
            boxShadow: 'none',
          },
          _focusVisible: {
            borderColor: 'blue.500',
            boxShadow: 'none',
          },
          _disabled: {
            bg: 'grey.50',
            borderColor: 'grey.300',
          },
          _valid: {
            borderColor: 'green.500',
          },
          _invalid: {
            borderColor: 'red.500',
          },
        },
        icon: {
          w: '18px',
          h: '18px',
          '> svg': {
            w: '18px',
            h: '18px',
            color: 'grey.400',
          },
        },
      };
    },
  },
  defaultProps: {
    variant: 'republic-outline',
    size: 'default',
  },
};
